import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-new-s.svg'
import _imports_1 from '@/assets/logo-new.svg'
import _imports_2 from '@/assets/menu.png'


const _withScopeId = n => (_pushScopeId("data-v-5682d387"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-primary-dark py-6 z-50" }
const _hoisted_2 = { class: "px-6 mx-auto" }
const _hoisted_3 = { class: "flex space-x-4 items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 xl:hidden",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 hidden xl:block",
  src: _imports_1
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_7 = { class: "hidden lg:flex space-x-4 mx-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "menu__item" }
const _hoisted_10 = { class: "hidden lg:flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-6",
  style: {"filter":"invert(1)"}
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "sidebar-panel"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "w-full"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-sm font-medium"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = { class: "py-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Logout ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-base text-right" }, "Contact"),
  /*#__PURE__*/_createElementVNode("div", { class: "ext-base text-right" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "mailto:contact@bringbacktheforest.org"
    }, "contact@bringbacktheforest.org")
  ])
], -1))
const _hoisted_26 = { class: "flex justify-center mt-4 space-x-4" }
const _hoisted_27 = ["href"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "my-2",
  style: {}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-xl font-semibold" }, "Logout", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-6 text-center text-lg" }, " Are you sure you want to logout? ", -1))
const _hoisted_32 = { class: "flex justify-center space-x-4" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Logout ")

import ModalWallet from '@/components/Modals/ModalWallet.vue';
import MenuAuthenticatedUser from '@/components/MenuAuthenticatedUser.vue';
import LandingFooter from '@/components/Landing/LandingFooter';
import { computed, ref } from 'vue';
import { Icon } from '@iconify/vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/user';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

const router = useRouter();
const isSidebarOped = ref<boolean>(false);
const ourPrograms = [
  { name: 'Join our volunteer program', to: '' },
  { name: 'Donate', to: '/donate' },
  { name: 'Plant a customized forest with BBTF', to: '' },
  { name: 'Carbon offset program', to: '' },
];

const goals = [
  { name: '10 Years Goals', to: '/landing/years-goals' },
  { name: 'Past Achievements', to: '/landing/past-achievements' },
  { name: 'Annual Report', to: '/landing/report' },
];

const menus = ref([
  { name: 'Our programs', to: '', children: ourPrograms, isToggle: false },
  { name: 'About us', to: '/landing/about-us' },
  { name: 'Our Forests', to: '/landing/forest' },
  { name: 'Goals', to: '', children: goals, isToggle: false },
  { name: 'FAQs & Blog', to: '/landing/faqs' },
  { name: 'Carbon Neutrality Solution', to: '/' },
  { name: 'Information NFTs', to: '/landing/information-nfts' },
]);

const socials = [
  {
    img: '/images/socials/fb.svg',
    to: 'https://web.facebook.com/Bringbacktheforest?_rdc=1&_rdr',
  },
  { img: '/images/socials/tw.svg', to: 'https://twitter.com/bbtfbbtf?s=21' },
  {
    img: '/images/socials/yt.svg',
    to: 'https://www.youtube.com/channel/UCgexR3KciJ3ZWsBOqV28HQA',
  },
  {
    img: '/images/socials/ig.svg',
    to: 'https://www.instagram.com/bringbacktheforestbbtf/?igshid=YmMyMTA2M2Y%3D',
  },
  {
    img: '/images/socials/tt.svg',
    to: 'https://www.tiktok.com/@bringbacktheforest',
  },
];

const showFooter = computed(
  () => router.currentRoute.value.name != 'ReceiveNFT'
);

const onClickOutside = () => {
  isSidebarOped.value = isSidebarOped.value ? false : true;
};

const closeSidebar = () => {
  isSidebarOped.value = false;
};

const meta_des = document.querySelector('meta[property="og:description"]');
const meta_des2 = document.querySelector('meta[name="description"]');
const meta_dfb = document.querySelector('meta[name="keywords"]');

if (meta_des && meta_des2 && meta_dfb) {
  meta_des.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );
  meta_des2.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );

  meta_dfb.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );
}

const isShowConfirmLogout = ref();
const logout = async () => {
  isShowConfirmLogout.value = true;
};
const logoutConfirm = async () => {
  isShowConfirmLogout.value = false;
  await userStore.logout();
  router.push('/landing');
};
const logoutCancel = () => {
  isShowConfirmLogout.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col", { 'justify-between': _unref(showFooter) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (m, i) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                to: m.to,
                key: `menu-${i}`,
                class: "text-white flex xl:text-sm text-xs whitespace-nowrap"
              }, {
                default: _withCtx(() => [
                  (!m.children)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(m.name), 1))
                    : _createCommentVNode("", true),
                  (m.name === 'Community')
                    ? (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        icon: "akar-icons:chevron-down",
                        class: "text-xl ml-2 mt-0.5"
                      }))
                    : _createCommentVNode("", true),
                  (m.children)
                    ? (_openBlock(), _createBlock(_component_VDropdown, {
                        key: 2,
                        "popper-hide-triggers": ['click'],
                        theme: "no-arrow",
                        placement: "bottom-end",
                        class: "flex"
                      }, {
                        popper: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.children, (g, i) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              to: g.to,
                              key: `menu-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(g.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(m.name), 1),
                          _createVNode(_unref(Icon), {
                            icon: "akar-icons:chevron-down",
                            class: "text-xl ml-1 h-4 mt-0.5"
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ModalWallet, null, {
              default: _withCtx(({ connectWallet, authenticated }) => [
                authenticated
                  ? (_openBlock(), _createBlock(MenuAuthenticatedUser, {
                      key: 0,
                      "with-dashboard": ""
                    }))
                  : (_openBlock(), _createBlock(_component_BaseButton, {
                      key: 1,
                      "color-scheme": "white",
                      height: "42px",
                      class: "my-2",
                      onClick: connectWallet
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "flex lg:hidden",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isSidebarOped.value = true))
          }, _hoisted_13)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (isSidebarOped.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_unref(Icon), {
                  onClick: closeSidebar,
                  icon: "ic:round-close",
                  class: "w-6 h-6 ml-auto"
                }),
                _createElementVNode("div", null, [
                  _createVNode(ModalWallet, null, {
                    default: _withCtx(({ authenticated }) => [
                      authenticated
                        ? (_openBlock(), _createBlock(MenuAuthenticatedUser, {
                            key: 0,
                            "with-dashboard": "",
                            sidebar: "",
                            class: "py-4"
                          }))
                        : _createCommentVNode("", true),
                      authenticated
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (m, i) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: m.to,
                    key: `menu-${i}`,
                    class: _normalizeClass(["sidebar-menu", { 'border-b': i < menus.value.length - 1 }])
                  }, {
                    default: _withCtx(() => [
                      (!m.children)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: closeSidebar
                          }, _toDisplayString(m.name), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", {
                              class: "flex items-center w-full",
                              onClick: ($event: any) => (m.isToggle = !m.isToggle)
                            }, [
                              _createElementVNode("span", null, _toDisplayString(m.name), 1),
                              _createVNode(_unref(Icon), {
                                icon: "akar-icons:chevron-down",
                                class: "text-xl ml-auto h-4 mt-0.5 mr-2"
                              })
                            ], 8, _hoisted_17),
                            (m.isToggle)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _hoisted_19,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.children, (g, index) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      to: g.to,
                                      key: `menu-${index}`,
                                      onClick: closeSidebar
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_20, _toDisplayString(g.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128)),
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createVNode(ModalWallet, null, {
                    default: _withCtx(({ connectWallet, authenticated }) => [
                      authenticated
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            "with-dashboard": "",
                            onClick: closeSidebar
                          }, [
                            _createVNode(_component_BaseButton, {
                              "color-scheme": "border",
                              height: "42px",
                              class: "my-4 w-full",
                              onClick: logout
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: closeSidebar
                          }, [
                            _createVNode(_component_BaseButton, {
                              "color-scheme": "primary",
                              height: "42px",
                              class: "my-4 w-full",
                              onClick: connectWallet
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                    ]),
                    _: 1
                  }),
                  _hoisted_24
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (s, i) => {
                    return _createElementVNode("a", {
                      key: `social-${i}`,
                      class: "m-1",
                      target: "_blank",
                      href: s.to
                    }, [
                      _createElementVNode("img", {
                        class: "w-8",
                        src: s.img
                      }, null, 8, _hoisted_28)
                    ], 8, _hoisted_27)
                  }), 64))
                ])
              ])), [
                [_directive_click_outside, onClickOutside]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view, {
      class: "content-center",
      style: {"min-height":"calc(100vh - 430px)"}
    }),
    _createElementVNode("div", null, [
      _createVNode(_unref(LandingFooter))
    ]),
    _createVNode(_component_BaseModal, {
      modelValue: isShowConfirmLogout.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowConfirmLogout).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_BaseButton, {
              "color-scheme": "white",
              onClick: logoutCancel
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }),
            _createVNode(_component_BaseButton, {
              "color-scheme": "primary",
              onClick: logoutConfirm
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})